import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

const trackPickUpInStoreSelection = (deliveryStoreId: string, isCheckoutPath: boolean) => {
  pushGTMEvent({
    event: 'Track',
    category: isCheckoutPath ? 'checkout_delivery_options' : 'delivery_widget',
    action: 'click_and_collect_confirmed',
    label: '',
    value: 0,
    delivery_store_id: deliveryStoreId,
  });
};

export default trackPickUpInStoreSelection;
